import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";
import { IMAGES } from "../../lib/i18n";

export default function Pistachio() {
  const { t } = useLang();
  const c = t.pistachio;
  return (
    <section data-testid="pistachio-section" className="py-24 sm:py-32 bg-ivory-pure border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 grid grid-cols-12 gap-y-12 gap-x-6 items-start">
        <div className="col-span-12 lg:col-span-7">
          <Reveal className="flex items-start gap-4 mb-6">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="h-section text-olive mb-10">
            {c.title}
          </Reveal>
          <Reveal>
            <p className="text-lg text-olive-soft leading-relaxed mb-5">{c.bodyA}</p>
          </Reveal>
          <Reveal>
            <p className="text-lg text-olive-soft leading-relaxed mb-12">{c.bodyB}</p>
          </Reveal>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-6">
            {c.pills.map((p, i) => (
              <Reveal key={i} delay={i * 80} className="border-t border-olive/30 pt-5">
                <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-3">{p.tag}</div>
                <p className="text-base text-olive leading-relaxed">{p.body}</p>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal className="col-span-12 lg:col-span-4 lg:col-start-9">
          <div className="aspect-[3/4] overflow-hidden">
            <img src={IMAGES.varieties} alt="Pistachos premium" className="w-full h-full object-cover" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
